import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Container,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useSelector } from "react-redux";

import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import SecurePageSection from "../../SecurePageSection";
import JsgPaymentModal from "../../components/JsgPaymentModal";

const GroupFormAEditForm = () => {
  const user = useSelector((state) => state.authentication.user);
  const location = useLocation();

  const [response, setResponse] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  const [regName, setRegName] = useState("");
  const [grpName, setGrpName] = useState("");
  const [grpNumber, setGrpNumber] = useState("");
  const [grpAddress, setGrpAddress] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [grpPresidentName, setGrpPresidentName] = useState("");
  const [grpSecretaryName, setGrpSecretaryName] = useState("");
  const [grpTreasurerName, setGrpTreasurerName] = useState("");
  const [grpPresidentNum, setGrpPresidentNum] = useState("");
  const [grpSecretaryNum, setGrpSecretaryNum] = useState("");
  const [grpTreasurerNum, setGrpTreasurerNum] = useState("");
  const [grpPresidentEmail, setGrpPresidentEmail] = useState("");
  const [grpSecretaryEmail, setGrpSecretaryEmail] = useState("");
  const [grpTreasurerEmail, setGrpTreasurerEmail] = useState("");
  const [CoupleMembers, setCoupleMembers] = useState("");
  const [SingleMembers, setSingleMembers] = useState("");
  const [amtToPay, setAmtToPay] = useState(5900);
  const [oldDuepayable, setOldDuepayable] = useState("");
  const [oldDueRedeemable, setOldDueRedeemable] = useState("");
  const [totalAmtPayable, setTotalAmtPayable] = useState(5900);
  const [amtPaid, setAmtPaid] = useState("");
  const [newDuepayable, setNewDuepayable] = useState("");
  const [newDueRedeemable, setNewDueRedeemable] = useState("");
  const [draft_chequeNum, setDraft_chequeNum] = useState("");
  const [chequedate, setChequedate] = useState("");
  const [drawnOn, setDrawnOn] = useState("");
  const [branchName, setBranchName] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [regEmails, setRegEmails] = useState("");
  const [defaultEmails, setDefaultEmails] = useState(
    "office@jsgif.co.in,amish@vadilaljewels.com, dj22parekh@gmail.com, ritu26873@gmail.com,toralsheth.ts11@gmail.com"
  );
  const [emailList, setEmailList] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    setEmailInput(e.target.value);
    const newValue = e.target.value.replace(/\s/g, ""); // replace all spaces with empty string
    setEmailList(newValue);
  };

  const redirectToResponse = (id) => {
    navigate(`/grp-form-a-response/${id}`, { replace: true });
  };

  const responseId = useParams();

  const fetchForms = async () => {
    const res = await axios.get(`/api/forms/group/grp-form-a/${responseId.id}`);

    setResponse(res.data);
    setRegName(res.data.regName);
    setGrpName(res.data.grpName);
    setGrpNumber(res.data.grpNumber);
    setGrpAddress(res.data.grpAddress);
    setName(res.data.name);
    setEmail(res.data.email);
    setPhone(res.data.phone);
    setGrpPresidentName(res.data.grpPresidentName);
    setGrpSecretaryName(res.data.grpSecretaryName);
    setGrpTreasurerName(res.data.grpTreasurerName);
    setGrpPresidentNum(res.data.grpPresidentNum);
    setGrpSecretaryNum(res.data.grpSecretaryNum);
    setGrpTreasurerNum(res.data.grpTreasurerNum);
    setGrpPresidentEmail(res.data.grpPresidentEmail);
    setGrpSecretaryEmail(res.data.grpSecretaryEmail);
    setGrpTreasurerEmail(res.data.grpTreasurerEmail);
    setCoupleMembers(res.data.CoupleMembers);
    setSingleMembers(res.data.SingleMembers);
    setOldDuepayable(res.data.oldDuepayable);
    setOldDueRedeemable(res.data.oldDueRedeemable);
    setNewDuepayable(res.data.newDuepayable);
    setNewDueRedeemable(res.data.newDueRedeemable);
    setDraft_chequeNum(res.data.draft_chequeNum);
    setChequedate(res.data.chequedate);
    setDrawnOn(res.data.drawnOn);
    setBranchName(res.data.branchName);
  };

  useEffect(() => {
    fetchForms();
  }, [regName, grpName]);

  const navigate = useNavigate();

  const amtPayable = () => {
    let amtToPayVal = amtToPay;
    let oldDuepayableVal = oldDuepayable;
    let oldDueRedeemableVal = oldDueRedeemable;
    if (!isNaN(amtToPay)) {
      amtToPayVal = 0;
    }

    if (!isNaN(oldDuepayable)) {
      oldDuepayableVal = 0;
    }

    if (!isNaN(oldDueRedeemable)) {
      oldDueRedeemableVal = 0;
    }
    let amt =
      Number(amtToPayVal) -
      Number(oldDueRedeemableVal) +
      Number(oldDuepayableVal);
    setTotalAmtPayable(amt);
  };

  useEffect(() => {
    // Calculate total amount payable after adding old due and subtracting old excess
    const calculatedTotalAmtPayable =
      +amtToPay + +oldDuepayable - +oldDueRedeemable;
    setTotalAmtPayable(calculatedTotalAmtPayable);

    if (totalAmtPayable > amtPaid) {
      const calculatedNewDuepayable = Math.abs(amtPaid - totalAmtPayable);
      setNewDuepayable(calculatedNewDuepayable);
      setNewDueRedeemable(0);
    } else if (totalAmtPayable < amtPaid) {
      const calculatedNewDueRedeemable = Math.abs(totalAmtPayable - amtPaid);
      setNewDueRedeemable(calculatedNewDueRedeemable);
      setNewDuepayable(0);
    } else {
      setNewDuepayable(0);
      setNewDueRedeemable(0);
    }
  }, [amtToPay, oldDuepayable, oldDueRedeemable, totalAmtPayable, amtPaid]);

  async function FormSubmit(event) {
    event.preventDefault();

    const finalEmail = defaultEmails + "," + email + "," + emailList;

    let formField = new FormData();

    formField.append("user", user.user_id);
    formField.append("grpName", grpName);
    formField.append("grpNumber", grpNumber);
    formField.append("grpAddress", grpAddress);
    formField.append("name", name);
    formField.append("email", email);
    formField.append("phone", phone);
    formField.append("grpPresidentName", grpPresidentName);
    formField.append("grpSecretaryName", grpSecretaryName);
    formField.append("grpTreasurerName", grpTreasurerName);
    formField.append("grpPresidentNum", grpPresidentNum);
    formField.append("grpPresidentNum", grpPresidentNum);
    formField.append("grpSecretaryNum", grpSecretaryNum);
    formField.append("grpTreasurerNum", grpTreasurerNum);
    formField.append("grpPresidentEmail", grpPresidentEmail);
    formField.append("grpSecretaryEmail", grpSecretaryEmail);
    formField.append("grpTreasurerEmail", grpTreasurerEmail);
    formField.append("CoupleMembers", CoupleMembers);
    formField.append("SingleMembers", SingleMembers);
    {
      oldDuepayable === null
        ? formField.append("oldDuepayable", 0)
        : formField.append("oldDuepayable", oldDuepayable);
    }
    {
      oldDueRedeemable === null
        ? formField.append("oldDueRedeemable", 0)
        : formField.append("oldDueRedeemable", oldDueRedeemable);
    }
    {
      totalAmtPayable === null
        ? formField.append("totalAmtPayable", 0)
        : formField.append("totalAmtPayable", totalAmtPayable);
    }
    {
      amtPaid === null
        ? formField.append("amtPaid", 0)
        : formField.append("amtPaid", amtPaid);
    }
    {
      newDuepayable === null
        ? formField.append("newDuepayable", 0)
        : formField.append("newDuepayable", newDuepayable);
    }
    {
      newDueRedeemable === null
        ? formField.append("newDueRedeemable", 0)
        : formField.append("newDueRedeemable", newDueRedeemable);
    }
    formField.append("draft_chequeNum", draft_chequeNum);
    formField.append("chequedate", chequedate);
    formField.append("drawnOn", drawnOn);
    formField.append("branchName", branchName);
    formField.append("emailList", finalEmail);

    await axios({
      method: "put",
      url: `/api/forms/group/grp-form-a/${response.id}`,
      data: formField,
    })
      .then(function(response) {
        console.log(response);
        redirectToResponse(response.data.id);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  const [groups, setGroups] = useState([]);
  const fetchGroups = async () => {
    const response = await axios.get(`/user/south/groups`);

    setGroups(response.data);
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  function setGroupData(e) {
    const selectedGroup = groups.find(
      (group) => group.group.toLowerCase() === e.target.value
    );
    setGrpName(e.target.value);
    setGrpNumber(selectedGroup.id);
  }

  return (
    <div>
      <Container>
        <Form>
          <Row>
            <Col md={8}>
              <h2>Group Form A Edit</h2>
            </Col>
            <Col md={4}>
              <Button
                className="btn--primary"
                onClick={() => setModalShow(true)}
              >
                JSG Payment Infdormation
              </Button>
              <JsgPaymentModal
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            {(() => {
              if (
                typeof user !== "undefined" &&
                typeof user.username !== "undefined"
              ) {
                return (
                  <>
                    <Form.Group as={Col}>
                      <Form.Label>Group Name</Form.Label>
                      <Form.Select
                        name="grpName"
                        value={grpName}
                        onChange={(e) => setGroupData(e)}
                      >
                        <option>Select your Group</option>
                        <option
                          value={user.jsgGroupName.toLowerCase()}
                          style={{ textTransform: "capitalize" }}
                        >
                          {user.jsgGroupName.charAt(0).toUpperCase() +
                            user.jsgGroupName.slice(1).toLowerCase()}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </>
                );
              } else
                return (
                  <>
                    <Form.Group as={Col}>
                      <Form.Label>Group Name</Form.Label>
                      <Form.Select
                        name="grpName"
                        value={grpName}
                        onChange={(e) => setGroupData(e)}
                      >
                        <option>Select your Group</option>
                        <option>
                          {user.jsgGroupName.charAt(0).toUpperCase() +
                            user.jsgGroupName.slice(1).toLowerCase()}
                        </option>
                        {/* {groups.map((group, index) => (
                          <option
                            key={index}
                            style={{ textTransform: "capitalize" }}
                            value={group.group.toLowerCase()}
                          >
                            {group.group.charAt(0).toUpperCase() +
                              group.group.slice(1).toLowerCase()}
                          </option>
                        ))} */}
                      </Form.Select>
                    </Form.Group>
                  </>
                );
            })()}

            <Form.Group as={Col}>
              <Form.Label>Group Number</Form.Label>
              <Form.Control
                name="grpNumber"
                value={grpNumber}
                // onChange={(e) => setGrpNumber(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Group Address</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="grpAddress"
                value={grpAddress}
                onChange={(e) => setGrpAddress(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Respondant's Name</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Respondant's Phone</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Respondant's Email</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>President Name</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="grpPresidentName"
                value={grpPresidentName}
                onChange={(e) => setGrpPresidentName(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Secretary Name</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="grpSecretaryName"
                value={grpSecretaryName}
                onChange={(e) => setGrpSecretaryName(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Treasurer Name</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="grpTreasurerName"
                value={grpTreasurerName}
                onChange={(e) => setGrpTreasurerName(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>President Number</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="grpPresidentNum"
                value={grpPresidentNum}
                onChange={(e) => setGrpPresidentNum(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Secretary Number</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="grpSecretaryNum"
                value={grpSecretaryNum}
                onChange={(e) => setGrpSecretaryNum(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Treasurer Number</Form.Label>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                name="grpTreasurerNum"
                value={grpTreasurerNum}
                onChange={(e) => setGrpTreasurerNum(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>President Email</Form.Label>
              <Form.Control
                name="grpPresidentEmail"
                value={grpPresidentEmail}
                onChange={(e) => setGrpPresidentEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Secretary Email</Form.Label>
              <Form.Control
                name="grpSecretaryEmail"
                value={grpSecretaryEmail}
                onChange={(e) => setGrpSecretaryEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Treasurer Email</Form.Label>
              <Form.Control
                name="grpTreasurerEmail"
                value={grpTreasurerEmail}
                onChange={(e) => setGrpTreasurerEmail(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Group as={Col}>
                <Form.Label>Couple Members</Form.Label>
                <Form.Control
                  name="CoupleMembers"
                  value={CoupleMembers}
                  onChange={(e) => setCoupleMembers(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col}>
                <Form.Label>Single Members</Form.Label>
                <Form.Control
                  name="SingleMembers"
                  value={SingleMembers}
                  onChange={(e) => setSingleMembers(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Amount to be Paid</Form.Label>
              <Form.Control readOnly name="amtToPay" value={amtToPay} />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Old Outstanding</Form.Label>
              <Form.Control
                name="oldDuepayable"
                value={oldDuepayable}
                // onChange={(e) => {
                //   let amtToPayVal = amtToPay;
                //   let oldDuepayableVal = e.target.value;
                //   let oldDueRedeemableVal = oldDueRedeemable;
                //   if (isNaN(amtToPayVal)) {
                //     amtToPayVal = 0;
                //   }

                //   if (isNaN(oldDuepayable)) {
                //     oldDuepayableVal = 0;
                //   }

                //   if (isNaN(oldDueRedeemable)) {
                //     oldDueRedeemableVal = 0;
                //   }
                //   let amt =
                //     Number(amtToPayVal) +
                //     Number(oldDuepayableVal) -
                //     Number(oldDueRedeemableVal);
                //   setTotalAmtPayable(amt);
                //   console.log("amt", amt);
                //   setOldDuepayable(e.target.value);
                // }}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Old Excess</Form.Label>
              <Form.Control
                name="oldDueRedeemable"
                value={oldDueRedeemable}
                // onChange={(e) => {
                //   let amtToPayVal = amtToPay;
                //   let oldDuepayableVal = oldDuepayable;
                //   let oldDueRedeemableVal = e.target.value;
                //   if (isNaN(amtToPayVal)) {
                //     amtToPayVal = 0;
                //   }

                //   if (isNaN(oldDuepayable)) {
                //     oldDuepayableVal = 0;
                //   }

                //   if (isNaN(oldDueRedeemable)) {
                //     oldDueRedeemableVal = 0;
                //   }
                //   let amt =
                //     Number(amtToPayVal) +
                //     Number(oldDuepayableVal) -
                //     Number(oldDueRedeemableVal);
                //   setTotalAmtPayable(amt);
                //   console.log("amt", amt);
                //   setOldDueRedeemable(e.target.value);
                // }}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Total Amount Payable</Form.Label>
              <Form.Control
                name="totalAmtPayable"
                value={totalAmtPayable}
                // onChange={amtPayable}
                readOnly
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Amount being Paid</Form.Label>
              <Form.Control
                name="amtPaid"
                value={amtPaid}
                onChange={(e) => {
                  // let dueamount =
                  //   Number(totalAmtPayable) - Number(e.target.value);
                  // if (dueamount > 0) {
                  //   setNewDuepayable(dueamount);
                  //   setNewDueRedeemable("");
                  // } else {
                  //   setNewDueRedeemable(Math.abs(dueamount));
                  //   setNewDuepayable("");
                  // }
                  setAmtPaid(e.target.value);
                }}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>New Outstanding</Form.Label>
              <Form.Control
                readOnly
                name="newDuepayable"
                value={newDuepayable}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>New Excess</Form.Label>
              <Form.Control
                readOnly
                name="newDueRedeemable"
                value={newDueRedeemable}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Draft/Cheque Number</Form.Label>
              <Form.Control
                name="draft_chequeNum"
                value={draft_chequeNum}
                onChange={(e) => setDraft_chequeNum(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="Date"
                name="chequedate"
                value={chequedate}
                onChange={(e) => setChequedate(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Bank Name</Form.Label>
              <Form.Control
                name="drawnOn"
                value={drawnOn}
                onChange={(e) => setDrawnOn(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Branch Name</Form.Label>
              <Form.Control
                name="branchName"
                value={branchName}
                onChange={(e) => setBranchName(e.target.value)}
              />
            </Form.Group>
          </Row>

          {submitting ? (
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-disabled">Submitting Please Wait</Tooltip>
              }
            >
              <Button
                style={{ marginTop: "30px" }}
                className="btn--outline--dark"
                disabled
              >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                Submiting
              </Button>
            </OverlayTrigger>
          ) : (
            <Button
              style={{ marginTop: "30px" }}
              className="btn--outline--dark"
              onClick={(e) => FormSubmit(e)}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              Submit
            </Button>
          )}
        </Form>
      </Container>
    </div>
  );
};

export default GroupFormAEditForm;
